import { ChevronLeft, ChevronRight } from "lucide-react";

export const totalOf = (r) => parseInt(r.headers["x-total-count"] || "0", 10);

export const Pager = ({ page, total, size, onPage, testid = "pager" }) => {
  const pages = Math.ceil(total / size);
  if (pages <= 1) return null;
  const go = (p) => { onPage(p); window.scrollTo({ top: 0, behavior: "smooth" }); };
  const btn = "flex h-10 items-center gap-1 rounded-full border-2 border-black/10 px-4 text-sm font-semibold transition-colors hover:border-black disabled:opacity-40 disabled:hover:border-black/10";
  return (
    <nav className="mt-10 flex items-center justify-center gap-3" data-testid={testid}>
      <button disabled={page <= 1} onClick={() => go(page - 1)} className={btn} data-testid={`${testid}-prev`}><ChevronLeft className="h-4 w-4" />Indietro</button>
      <span className="text-sm text-stone-600" data-testid={`${testid}-status`}>Pagina {page} di {pages}</span>
      <button disabled={page >= pages} onClick={() => go(page + 1)} className={btn} data-testid={`${testid}-next`}>Avanti<ChevronRight className="h-4 w-4" /></button>
    </nav>
  );
};
